import React from 'react'
import styled from 'styled-components'
import dynamic from 'next/dynamic'
import { ProductCarousel } from '../ProductCarousel'
import { ModalProps } from '../../../Common/Modal'

const Modal = dynamic<ModalProps>(
  () => import('../../../Common/Modal').then((mod) => mod.Modal),
  {
    ssr: false,
  }
)

export const ProductImageListModal = ({
  hide,
  selectedImageIndex = 0,
}: {
  hide: Function
  selectedImageIndex: number
}) => {
  return (
    <Modal noContentPadding noTitlePadding full open handleClose={hide}>
      <Container>
        <ProductCarousel initialSlide={selectedImageIndex} isInModal />
      </Container>
    </Modal>
  )
}

const Container = styled.div.attrs({
  className: 'px-4 px-lg-5 d-flex justify-content-center pt-5 mt-5',
})`
  height: 100vh;
`
